<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>生产管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入材料名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->
        <el-table :data="datalist" border stripe >
          <el-table-column prop="Bomsn" label="材料编号" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="材料名称" min-width="10%"></el-table-column>
          <el-table-column prop="NumQiChuKuCun" label="期初库存" min-width="10%"></el-table-column>
          <el-table-column prop="NumCaigouReceive" label="采购入库1(交付)" min-width="10%"></el-table-column>
          <el-table-column prop="NumCaigouRuku" label="采购入库2(退货/退货入账/换货)" min-width="15%"></el-table-column>
          <el-table-column prop="NumShengchanReceive" label="生产入库1(交付)" min-width="10%"></el-table-column>
          <el-table-column prop="NumShengchanRuku" label="生产入库2(退货/退货入账/换货)" min-width="15%"></el-table-column>
          <el-table-column prop="NumChuKu" label="出库" min-width="10%"></el-table-column>
          <el-table-column prop="NumQiMoKuCun" label="期末库存" min-width="10%"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

      </el-tab-pane>
      <!-- 清单列表 end -->

    </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyProductinventory',
  data () {
    return {
      keywords: {
        jigouid: '-1',
        jigouname: '',
        begintime: '',
        endtime: '',
        name: '',
        bomsn: ''
      },
      selectedPageNo: 1,
      datalist: [],
      dataListnum: 0
    }
  },
  mounted () {
    this.apiGetproductinventorylist()
    this.apiGetproductinventorynum()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetproductinventorylist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetproductinventorylist()
      this.apiGetproductinventorynum()
    },
    apiGetproductinventorylist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductinventorylist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.datalist = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetproductinventorynum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getproductinventorynum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
